/* 🤖 this file was generated by script */
export const wiconLoading01 = {
  name: 'loading_01',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 2.25v2.5M12 18v4M5.75 12h-3.5m19 0h-1.5m-1.3 6.46l-.7-.71m.91-12.33l-1.41 1.41M4.92 19.08l2.83-2.83M5.13 5.21l2.12 2.12"/></svg>`,
};
